import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { BackHeader } from "@/components/TopBar";
import { Spinner } from "@/components/common";
import { Input } from "@/components/ui/input";
import { ListingRailCard } from "@/components/ListingCard";
import { PersonRailCard } from "@/components/PersonCard";
import { TribeCard } from "@/components/TribeCard";
import { Search as SearchIcon } from "lucide-react";

export default function SearchPage() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);

  const run = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setLoading(true);
    try { const { data } = await api.get("/search", { params: { q } }); setRes(data); }
    finally { setLoading(false); }
  };

  const suggestions = ["Bangalore", "Koramangala", "HSR Layout", "Pune", "Mumbai", "Designer"];

  return (
    <div>
      <BackHeader title="Search" />
      <div className="px-4 pt-4">
        <form onSubmit={run} className="relative">
          <SearchIcon className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-ink-soft" />
          <Input data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)} autoFocus placeholder="Cities, localities, rooms, people…" className="h-13 rounded-full border-border bg-white py-3.5 pl-12 pr-4" />
        </form>

        {!res && (
          <div className="mt-5">
            <p className="mb-2 text-sm font-semibold text-ink-soft">Try searching</p>
            <div className="flex flex-wrap gap-2">
              {suggestions.map((s) => <button key={s} onClick={() => { setQ(s); setTimeout(() => run({ preventDefault() {} }), 0); }} className="rounded-full bg-white px-4 py-2 text-sm font-semibold text-ink shadow-soft">{s}</button>)}
            </div>
          </div>
        )}

        {loading && <Spinner />}

        {res && !loading && (
          <div className="mt-5 space-y-6">
            {res.listings?.length > 0 && (
              <section>
                <h3 className="mb-2 font-heading text-lg font-bold text-ink">Rooms</h3>
                <div className="no-scrollbar -mx-4 flex gap-3 overflow-x-auto px-4 pb-2">{res.listings.map((l) => <ListingRailCard key={l.listing_id} listing={l} />)}</div>
              </section>
            )}
            {res.people?.length > 0 && (
              <section>
                <h3 className="mb-2 font-heading text-lg font-bold text-ink">People</h3>
                <div className="no-scrollbar -mx-4 flex gap-3 overflow-x-auto px-4 pb-2">{res.people.map((p) => <PersonRailCard key={p.user_id} person={p} />)}</div>
              </section>
            )}
            {res.tribes?.length > 0 && (
              <section>
                <h3 className="mb-2 font-heading text-lg font-bold text-ink">Tribes</h3>
                <div className="space-y-4">{res.tribes.map((t) => <TribeCard key={t.tribe_id} tribe={t} />)}</div>
              </section>
            )}
            {!res.listings?.length && !res.people?.length && !res.tribes?.length && (
              <p className="py-10 text-center text-ink-soft">No results for "{q}"</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
